import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "daysField", "rechargesField"];

  connect() {
    if (this.hasSelectTarget) this.toggle();
  }

  toggle() {
    const control = this.timingControl;
    // No recognisable control: leave the server-rendered visibility alone.
    if (!control) return;

    const isRecharges = control.value.startsWith("recharges");

    if (this.hasDaysFieldTarget) {
      this.daysFieldTarget.style.display = isRecharges ? "none" : "";
    }
    if (this.hasRechargesFieldTarget) {
      this.rechargesFieldTarget.style.display = isRecharges ? "" : "none";
    }
  }

  // The target is a native <select>, a wrapper around one, or a wrapper around a shadcn select.
  get timingControl() {
    const target = this.selectTarget;
    return target.tagName === "SELECT"
      ? target
      : target.querySelector("select, input[data-select-target='hiddenInput']");
  }
}
